import React, { Component, Fragment } from 'react';
import { Row, Col, Carousel, List, Divider, Button, Icon, Card } from 'antd';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import YouTube from 'react-youtube';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
 
import NextArrow from './components/NextArrow';
import PrevArrow from './components/PrevArrow';
import HomeMenu from '../../components/layouts/HomeMenu';

import { getInitials, getAnnouncements } from '../../actions';

import {loadJson} from '../../utils/loadjson';
const homeLayout = loadJson( '/assets/home.json');

const showSliders = homeLayout.showSliders;
const showCategories = homeLayout.showCategories;
const showBlocks = homeLayout.showBlocks;
const showVideos = homeLayout.showVideos;
const showLinks = homeLayout.showLinks;
const showNews = homeLayout.showNews;
const showArticles = homeLayout.showArticles;
const homeLines = homeLayout.homeLines;

function getYoutubeId(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
}

const DEFAULT_IMAGE = '/assets/images/default.png';

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

const SlickSlide = styled.div`
  text-align: center;
  height: 230px;
  line-height: 230px;
  background: #364d79;
  overflow: hidden;
  color: #FFF;
`;

const SlideImage = styled.div`
  overflow: hidden;
  background-size: cover;
  background-position: center;
  height: 230px;
  background-color: #364d79;
  background-image: url(${props => props.src});
`;

const SponsorWrapper = styled(SlickSlide) `
  height: 150px;
  line-height: 150px;
  padding: 0px 10px;
  background: transparent;
  justify-content: center;
  display: flex !important;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h3`
  font-weight: 600;
  color: #FB5422;
`;

const WidgetImage = styled.div`
  overflow: hidden;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 150px;
  margin-top: 20px;
  background-color: #DEE4E8;
  background-image: url(${props => props.src || DEFAULT_IMAGE});
`;

const ArticleThumb = styled.div`
  overflow: hidden;
  background-size: cover;
  background-position: center;
  height: 50px;
  width: 80px;
  background-color: #DEE4E8;
  background-image: url(${props => props.src || DEFAULT_IMAGE});
`;

const StatisticWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 16px;
    color: #fff;
    margin-bottom: 0px;
    width: 50%;
  }
  h2 {
    color: #fff;
    font-size: 33px;
    margin-bottom: 0px;
  }
`;

const InfoCard = styled.div`
    cursor: pointer;
    margin-bottom: 10px;
    background-color: #FB5422;
    padding: 15px;
    border-radius: 4px;
    h3 {
      color: #fff;
    }
    img {
      background-color: #DEE4E8;
      height: 150px;
      width: 100%;
    }
  `;

const sponsorResponsive = [
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 4,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
    },
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
    },
  },
];


function truncate(str, n) {
  return (str.length > n) ? `${str.substr(0, n - 1)}...` : str;
}

class Home extends Component {
  
  componentWillMount = () => {
    this.props.getInitials(showArticles);
    this.props.getAnnouncements(showNews);
  };

  getVideoTitle = (title, n) => truncate(title[0].value, n || 100)

  getVideoDesc = (description, n) => truncate(description[0].value, n || 200)

  renderWidget = item => ( 
    <List.Item style={{ marginBottom: 0 }}>
      <Divider orientation="left" className="divider-center">
        <Link to={`/danh-muc/${item.slug}-${item._id}`}>
          <Title>
            {(this.props.locale === 'en' && item.engName)
              ? item.engName.toUpperCase()
              : item.name.toUpperCase()
            }
          </Title>
        </Link>
      </Divider>
      <WidgetImage src={item.featuredImage} />
      <List
        className="home-widget-list"
        style={{marginTop: 10,  minHeight: (showArticles*homeLines*25 )+10}} // 
        dataSource={item.articles.filter(i => i.language === this.props.locale)}
        renderItem={i => (
          <React.Fragment>
          <Link to={`/bai-viet/${i.slug}-${i._id}`}>
            <List.Item style={{ marginBottom: 10, padding: 0 , minHeight: homeLines*25 }} key={i._id}>
              <List.Item.Meta
                avatar={<ArticleThumb src={i.featuredImage} className='only-desktop' />}
                title={
                  i.highlight ?
                    <div style={{ position: 'relative' }}>
                      <ResponsiveEllipsis
                        text={`‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎${i.title}`}
                        maxLine={homeLines}
                      />
                      <img alt="hot-news" src="/assets/images/hot-news.gif" style={{ position: 'absolute', top: 3, left: 0, width: 32, height: 16 }} />
                    </div>
                    : <ResponsiveEllipsis
                      text={i.title}
                      maxLine={homeLines}
                    />
                }
              />
            </List.Item>
          </Link>
         </React.Fragment>
        )}
      />
      <Link to={`/danh-muc/${item.slug}-${item._id}`} style={{ position: 'absolute', bottom: -15, right: 0 }}>
        <Button style={{ float: 'right' }} type="primary">
          <FormattedMessage id="Home.More" />
        </Button>
      </Link>
    </List.Item>
  )

  render() {
    const { app: { sponsors, carousels, displayCategories, videos, blocks, stats }, announcements, locale } = this.props;
    return (
      <div>
      {showSliders &&
        <Fragment>
        <Row gutter={10}>
          <Col md={{ span: 24 }} lg={{ span: 24 }}>
            <Carousel autoplay>
              {carousels.filter(c => c.active).map(item => (
                <SlickSlide key={item._id} md={{ span: 12 }} lg={{ span: 16 }} >
                  <SlideImage src={item.image} />
                </SlickSlide>
              ))}
            </Carousel>
          </Col>
        </Row>
        </Fragment>
      }
     {true && 
        <Fragment>
        <Row gutter={10}>
          <Col xl={6} lg={6} md={12} sm={24} >
            <HomeMenu />
          </Col>
          <Col xl={10} lg={10} md={12} sm={24}>
            <Divider orientation="left" className="divider-center">
              <Title>
                <FormattedMessage id="Home.Announcements" />
              </Title>
            </Divider>
            <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={() => { }}
              hasMore={false}
              useWindow={false}
              style={{ overflow: 'auto', height: '100%', marginBottom: 10 }}
            >
              <List
                dataSource={announcements.filter(i => i.language === locale)}
                //style={{ minHeight: (showNews*homeLines*25 )+10}}

                renderItem={i => (
                  <React.Fragment>
                    <Link to={`/bai-viet/${i.slug}-${i._id}`}>
                      <List.Item style={{ padding: 0, marginTop: 10, marginBottom: 10 }} key={i._id}>
                        <div style={{ display: 'inline' }}>
                          <p style={{ color: '#111', display: 'inline' }}>
                            <Icon type='caret-right' style={{ fontSize: 12, color: '#FB5422', marginRight: 5 }} />
                            {i.title}
                          </p>
                          <p style={{ color: '#CCC', marginLeft: 5, fontSize: 12, marginTop: 3, display: 'inline' }}>
                            {moment(i.createdAt).format('L')}
                          </p>
                          {i.highlight && <Icon type='pushpin' style={{ fontSize: 14, color: '#FB5422', marginLeft: 5, marginTop: 3 }} />}
                        </div>
                      </List.Item>
                    </Link>
                    <Divider style={{ width: '97%', margin: 0, padding: 0 }} />
                  </React.Fragment>
                )}
              />
            </InfiniteScroll>
            {announcements.filter(i => i.language === locale).length > 0 && <Link
              to={'/thong-bao'}
              style={{ display: 'block', height: 50 }}
            >
              <Button style={{ float: 'right', marginBottom: 20 }} type="primary">
                <FormattedMessage id="Home.More" />
              </Button>
            </Link>}
          </Col>
          <Col lg={8} xl={8} md={24} style={{ padding: '0px 10px',  marginTop: 20, marginBottom: 20 }}>
            <Row style={{ marginTop: 10 }} gutter={10}>
              {stats.map((stat, idx) => (
                <Col xl={24} lg={24} md={8} sm={24}>
                  <Link to={blocks[idx].title.find(i => i.lang === locale) ? blocks[idx].title.find(i => i.lang === locale).url : blocks[idx].title[0].url}>
                  <Card key={stat._id} hoverable bordered={false} style={{ marginBottom: idx < stats.length ? 15 : 0, backgroundColor: stat.color }}>
                    <StatisticWrap>
                      <span>{stat.title.find(i => i.lang === locale) ? stat.title.find(i => i.lang === locale).value : stat.title[0].value}</span>
                      <h2>{stat.count} </h2>
                    </StatisticWrap>
                  </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        </Fragment>
       }
       { showCategories >0 &&
        <Fragment>
        <Row gutter={10}>
          {displayCategories.slice(0, showCategories).map(item => (
            <Col key={item._id} xl={8} md={12} sm={24}>
              {this.renderWidget(item)}
            </Col>
          ))}
        </Row>
        <Divider />        
        </Fragment>
       }        
      {showBlocks &&
        <Fragment>
        <Row gutter={16}>
          {blocks.map(block => (
            <Col key={block._id} xl={8} md={8} sm={24}>
              <Link to={block.title.find(i => i.lang === locale) ? block.title.find(i => i.lang === locale).url : block.title[0].url}>
                <InfoCard style={{ backgroundColor: block.color || '#FB5422' }}>
                  <h3>{block.title.find(i => i.lang === locale) ? block.title.find(i => i.lang === locale).value : block.title[0].value}</h3>
                  <img src={block.thumbnail} style={{ objectFit: 'cover' }} />
                </InfoCard>
              </Link>
            </Col>
          ))}
        </Row>
        <Divider />
        </Fragment>
      }
     { showVideos && 
        <Fragment>
        <Row style={{ marginTop: 10 }} gutter={16}>
          <h2>Video clips</h2>
          <Col xl={16} lg={16} md={24} sm={24}>
            {videos && videos.length > 0 && (
              <Card
                hoverable
                onClick={() => window.open(videos[0].url, '__blank')}
                cover={
                  <YouTube videoId={getYoutubeId(videos[0].url)} opts={{ height: 300, width: '100%' }} />
                }
              >
                <Card.Meta title={this.getVideoTitle(videos[0].title)} description={<div dangerouslySetInnerHTML={{ __html: this.getVideoDesc(videos[0].description) }} />} />
              </Card>
            )}
          </Col>
          <Col xl={8} lg={8} md={24} sm={24}>
            <List
              itemLayout="horizontal"
              dataSource={videos.slice(1, 4)}
              renderItem={item => (
                <List.Item style={{ cursor: 'pointer' }} onClick={() => window.open(item.url, '__blank')}>
                  <List.Item.Meta
                    avatar={<img src={item.thumbnail} style={{ width: 160, height: 90, borderRadius: 4 }} />}
                    title={this.getVideoTitle(item.title)}
                    description={<div dangerouslySetInnerHTML={{ __html: this.getVideoDesc(item.description, 70) }} />}
                  />
                </List.Item>
              )}
            />
          </Col>
        </Row>
        <Divider />
       </Fragment>
      }        
     { showLinks &&
       <Fragment>
        <Row style={{ marginTop: 10 }}>
          <h2>
            <FormattedMessage id="Home.DonViLienKet" />
          </h2>
          <Carousel
            arrows
            dots={false}
            infinite
            slidesToShow={5}
            autoplay
            autoplaySpeed={2000}
            nextArrow={<NextArrow />}
            prevArrow={<PrevArrow />}
            responsive={sponsorResponsive}
          >
            {sponsors.map(item => (
              <SponsorWrapper key={item._id}>
                <a href={item.url}>
                  <div style={{ flex: 1, display: 'flex', width: '100%', padding: '0px 20px', backgroundColor: '#F4F4F4', borderRadius: 5 }}>
                    <img
                      src={item.image}
                      style={{ flex: 1, display: 'flex', width: '100%', height: 'auto', objectFit: 'contain' }}
                      alt={item.title}
                    />
                  </div>
                </a>
              </SponsorWrapper>
            ))}
          </Carousel>
        </Row>
       </Fragment>
      }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  announcements: state.article.announcements,
  locale: state.intl.locale,
});

const mapDispatchToProps = {
  getInitials,
  getAnnouncements,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/screens/Home/Home.js